const hostname = window && window.location && window.location.hostname;

export const TIMER_LENGTH = hostname !== "localhost" && !hostname.includes("staging") ? 30000 : 5000;
